export const getVideoUrl = (url = '') => {
  return `${url}?avthumb/mp4/vcodec/libx264`
}
